import { useContractActivationFinalization } from '../../../../../hooks/contracts/subscriptions/activation/ActivationFinalizationHook'
import React, { useEffect } from 'react'
import ActivityProgression, { ProgressionStatus } from '../../../common/ActivityProgression'

export function Finalization({
  charityId,
  contractId,
  success,
  failure,
}: {
  charityId: string
  contractId: string
  success: () => Promise<void>
  failure: (e: unknown) => void
}): JSX.Element {
  const { state, finalize } = useContractActivationFinalization({ charityId, contractId, success, failure })

  useEffect(() => {
    void finalize()
  }, [])
  return (
    <div>
      <ActivityProgression status={getFinalizationProgressionStatus(state)} />
    </div>
  )
}

function getFinalizationProgressionStatus(state: 'idle' | 'finalize' | 'success'): ProgressionStatus {
  switch (state) {
    case 'idle':
      return { status: 'idle' }
    case 'finalize':
      return { status: 'pending' }
    case 'success':
      return { status: 'success' }
  }
}
